import { render, staticRenderFns } from "./section-rr-frequency.vue?vue&type=template&id=141f4bc0&scoped=true"
import script from "./section-rr-frequency.vue?vue&type=script&lang=js"
export * from "./section-rr-frequency.vue?vue&type=script&lang=js"
import style0 from "./section-rr-frequency.vue?vue&type=style&index=0&id=141f4bc0&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "141f4bc0",
  null
  
)

export default component.exports